export const callback = '/callback'

export const silentRenew = '/silent-renew'

export const unauthorized = '/unauthorized'

export const users = '/'

export const roles = '/roles'

export const settings = '/settings'
